import LogoText from './LogoText.vue';

export default LogoText;
